import Card from 'components/card';
import { ChannelIcon } from 'components/icons';
import { useNavigate } from 'react-router-dom';

const OfferCard = (props: {
    image: string;
    offerNumber: string;
    title: string;
    author: string;
    download?: string;
    price: string | number;
    weeklyQuantity?: string | number;
    extra?: string;
    status?: string;
    buttonDisabled?: boolean;
    isKYCVerified?: boolean;
    isValidated?: boolean;
    isArchived?: boolean;
    tested: boolean;
    channels: any;
    id: string;
    onClick?: () => void;
}) => {
    const {
        title,
        author,
        image,
        extra,
        status,
        isArchived,
        weeklyQuantity,
        offerNumber,
        onClick,
        channels,
        tested,
        id,
    } = props;
    const nav = useNavigate();

    return (
        <Card
            extra={`relative flex flex-col w-full h-full !p-4 3xl:p-![18px] border-2 shadow-xl bg-white ${extra} hover:cursor-pointer hover:shadow-xl`}
        >
            <div className="h-full w-full">
                <div className="relative w-full">
                    <img
                        src={image}
                        className="mb-3 max-h-[130px] w-full rounded-xl 3xl:h-full 3xl:w-full"
                        alt=""
                    />
                </div>

                <div className="flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
                    <div className="">
                        <div className="flex gap-2">
                            <p className="text-lg font-bold text-navy-700 dark:text-white">
                                {' '}
                                {title}{' '}
                            </p>
                            <p className="my-auto flex text-xs font-bold text-gray-600">
                                #{offerNumber}
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <p className="text-sm font-medium text-gray-600 md:mt-2">
                                {author}
                            </p>
                            <div className="mt-3 flex gap-2">
                                {channels?.map((channel: string) => (
                                    <div className="text-leadrs">
                                        <ChannelIcon channel={channel} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        {status === 'running' && (
                            <p className="mt-2 text-sm font-bold text-leadrs">
                                Mission en cours
                            </p>
                        )}
                        {status === 'on_market' && (
                            <p className="mt-2 text-sm font-bold text-leadrs">
                                En attente...
                            </p>
                        )}
                        {isArchived && (
                            <p className="mt-2 text-sm font-bold text-leadrs">
                                Mission terminée
                            </p>
                        )}
                    </div>
                </div>
                {/* <div className="mt-2 flex items-center justify-between md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col 2xl:items-start 3xl:flex-row 3xl:items-center 3xl:justify-between">
                    <div className="flex">
                        <p className="mb-2 text-sm font-bold text-leadrs dark:text-white">
                            {weeklyQuantity} leads
                        </p>
                    </div>
                </div> */}
                {tested ? (
                    <button
                        className="linear mt-4 flex w-full items-center justify-center rounded-xl bg-green-600 px-5 py-2 text-xs font-medium text-white transition duration-200"
                        onClick={onClick}
                        disabled={true}
                    >
                        Intégration réussie
                    </button>
                ) : (
                    <button
                        className="linear mt-4 flex items-center justify-end rounded-xl bg-leadrs px-5 py-2 text-xs font-medium text-white transition duration-200 hover:bg-leadrsLight"
                        onClick={() => nav(`/admin/integrate-offer/${id}`)}
                    >
                        Connecter l'offre avec mon CMS
                    </button>
                )}
            </div>
        </Card>
    );
};

export default OfferCard;
